<template>
  <el-row>
    <el-col :span="24">
      <basic-container>
        <avue-crud :option="option"
                   :search.sync="search"
                   :table-loading="loading"
                   :data="data"
                   ref="crud"
                   v-model="form"
                   @row-del="rowDel"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   :before-open="beforeOpen"
                   :page.sync="page"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="refreshChange"
                   @on-load="onLoad">
<!--          <template slot="menuLeft">-->
<!--            <el-button type="danger"-->
<!--                       size="small"-->
<!--                       plain-->
<!--                       icon="el-icon-delete"-->
<!--                       v-if="permissionList.delBtn"-->
<!--                       @click="handleDelete()">删 除-->
<!--            </el-button>-->
<!--          </template>-->

<!--   退款按钮是否显示       v-if="scope.row.settementFlag === '0'"-->
          <template slot-scope="scope" slot="menu">
            <el-button
              size="small"

              icon="el-icon-setting"
              @click="refundClick(scope.row)"
              type="text"
            >退款
            </el-button>
          </template>
        </avue-crud>
        <el-dialog
          title="退款金额"
          append-to-body
          :close-on-click-modal="false"
          :visible.sync="box"
          width="300px"
        >
          <el-input v-model="leftAmount"></el-input>
          <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="box = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="submit">确 定</el-button>
          </span>
        </el-dialog>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
  import {getList, remove, update, save, view} from "@/api/busin/businPayOrder";
  import { refund } from "@/api/wx/wx";

  export default {
    data() {
      return {
        leftAmount:0,
        orderNo:'',
        rentDay:0,
        rentCount:0,
        box:false,
        form: {},
        search:{},
        selectionList: [],
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        option: {
          height: 'auto',
          calcHeight: 80,
          align: 'center',
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          selection: true,
          // viewBtn: true,
          editBtn:false,
          delBtn:false,
          addBtn:false,
          searchIndex:3,
          searchIcon:true,
          // dialogType: 'drawer',
          dialogClickModal: false,
          dialogDrag: true,
          column: [
            // {
            //   label: "PayID",
            //   prop: "payId",
            //   search: true,
            //   rules: [
            //   ]
            // },
            // {
            //   label: "微信OpenID",
            //   prop: "wxOpenid",
            //   search: true,
            //   rules: [
            //     {
            //       required: true,
            //       message: "请输入微信OpenID",
            //       trigger: "blur"
            //     }
            //   ]
            // },
            {
              label: "姓名",
              prop: "name",
              search: true,
              rules: [
              ]
            },
            {
              label: "电话",
              prop: "telephone",
              search: true,
              rules: [
              ]
            },
            {
              label: "科室",
              prop: "deptName",
              width:'60',
              // search: true,
              rules: [
              ]
            },
            {
              label: "楼层",
              prop: "floorName",
              width:'80',
              // search: true,
              rules: [
              ]
            },
            {
              label: "已租天数",
              prop: "rentDay",
              width:'80',
              rules: [
              ]
            },
            {
              label: "数量",
              prop: "rentCount",
              width:'50',
              rules: [
              ]
            },
            {
              label: "总金额",
              prop: "totalFee",
              width:'80',
              rules: [
              ]
            },
            {
              label: "剩余金额",
              prop: "leftAmount",
              width:'80',
              rules: [
              ]
            },
            {
              label: "是否支付",
              prop: "payStatus",
              width:'80',
              dicData:[
                {label:'是',value:'1'},
                {label:'否',value:'0'}
              ]
            },
            {
              label: "是否结账",
              prop: "settementFlag",
              width:'80',
              search: true,
              type:'select',
              dicData:[
                {label:'是',value:'1'},
                {label:'否',value:'0'}
              ],
              rules: [
              ]
            },
            {
              label: "租赁日期",
              prop: "createTime",
              type: "datetime",
              // type: "daterange",
              // format:'yyyy-MM-dd',
              valueFormat:'yyyy-MM-dd HH:mm:ss',
              startPlaceholder: '日期开始范围',
              endPlaceholder: '日期结束范围',
              search: true,
              searchRange: true,
              rules: [
              ]
            },
          ],
        },
        data: []
      };
    },
    computed: {
    },
    methods: {
      submit(){
        console.log(this.rentDay);
        refund(this.orderNo,this.leftAmount,'2').then(res => {
          if(res.data.code === '0') {
            this.box = false
            this.$message({
              type: 'success',
              message: res.data.data
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      },
      refundClick(row) {
        this.box = true;
        this.rentDay = row.rentDay;
        this.leftAmount = row.leftAmount;
        console.log(this.rentDay);
        //退款
        this.orderNo = row.orderNo;
        this.rentCount = row.rentCount;
      },
      rowSave(row, done, loading) {
        // this.$request.processResp(() => save(row), () => this.onLoad(this.page),done, loading)
      },
      rowUpdate(row, index, done, loading) {
        // this.$request.processResp(() => update(row), () => this.onLoad(this.page),done, loading)
      },
      rowDel(row) {
        // this.handleDelete(row.telephone)
      },
      searchReset() {
        this.query = {};
        this.onLoad(this.page);
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad(this.page, params);
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      handleDelete(id) {
        var ids = id ? [id] : this.selectionList.map(item => {
          return item.telephone
        })
        if (ids.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          return this.$request.processResp(() => remove(ids), () => this.onLoad(this.page), ()=>this.$refs.crud.toggleSelection(), ()=>{})
        });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          view(this.form.telephone).then(res => {
            this.form = res.data.data;
          });
        }
        done();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      refreshChange() {
        this.onLoad(this.page, this.query);
      },
      onLoad(page, params = {}) {
        this.loading = true;
        getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(res => {
          const data = res.data;
          if (data && data.code === '0') {
            this.page.total = data.data.total;
            this.data = data.data.records;
            this.selectionClear();
          } else {
            this.$message.error(data.msg)
          }
          this.loading = false;
        });
      }
    }
  };
</script>

<style scoped>
/*.el-dialog{*/
/*  left: 50% !important;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/views/busin/businPayOrder.vue